import React from 'react';
import { Link } from 'react-router-dom';
import OptimizedImage from './OptimizedImage';

const siteLinks = [
  { to: '/about', label: 'About' },
  { to: '/contact', label: 'Contact' },
  { to: '/blog', label: 'Blog' },
  { to: '/#pricing', label: 'Pricing' },
];

const legalLinks = [
  { to: '/privacy-policy', label: 'Privacy Policy' },
  { to: '/terms-of-service', label: 'Terms of Use' },
];

export default function SiteFooter() {
  return (
    <footer className="footer">
      <div className="footer-accent" aria-hidden />
      <div className="container footer-shell">
        <div className="footer-grid">
          <div className="footer-brand">
            <Link to="/" className="footer-logo-link" aria-label="Notrack home">
              <OptimizedImage
                src={`${process.env.PUBLIC_URL}/white.png`}
                alt="Notrack weight loss app logo"
                className="footer-logo-img"
                width={360}
                height={90}
                loading="lazy"
                decoding="async"
                fetchPriority="low"
              />
            </Link>
            <p className="footer-tagline">
              Simple nutrition and habit guidance for India—without calorie tracking.
            </p>
            <p className="footer-tagline" style={{ marginTop: '0.6rem' }}>
              Support:{' '}
              <a
                href="https://wa.me/919959167972"
                target="_blank"
                rel="noopener noreferrer"
                className="footer-link flex items-center gap-2"
                aria-label="Chat with Notrack support on WhatsApp"
              >
                <svg
                  width="18"
                  height="18"
                  viewBox="0 0 32 32"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  aria-hidden="true"
                  focusable="false"
                >
                  <path
                    d="M27.6 4.4A15.35 15.35 0 0 0 16.1 0C7.3 0 .2 7.1.2 15.9c0 2.8.7 5.4 2 7.8L0 32l8.5-2.2c2.3 1.2 5 1.9 7.7 1.9 8.8 0 15.9-7.1 15.9-15.9 0-4.2-1.6-8.2-4.5-11.4Z"
                    fill="currentColor"
                    opacity="0.22"
                  />
                  <path
                    d="M16.1 29.1c-2.4 0-4.8-.6-6.9-1.8l-.5-.3-5.1 1.3 1.4-4.9-.3-.5a12.99 12.99 0 0 1-2-7c0-7.2 5.9-13.1 13.1-13.1 3.5 0 6.8 1.4 9.3 3.9a13.02 13.02 0 0 1 3.9 9.3c0 7.2-5.9 13.1-13.1 13.1Z"
                    fill="currentColor"
                  />
                  <path
                    d="M23.7 19.3c-.4-.2-2.3-1.1-2.7-1.3-.4-.1-.7-.2-1 .2-.3.4-1.1 1.3-1.3 1.6-.2.3-.5.3-.9.1-.4-.2-1.7-.6-3.2-2-1.2-1.1-2-2.5-2.2-2.9-.2-.4 0-.6.2-.8.2-.2.4-.5.6-.7.2-.2.3-.4.4-.7.1-.2.1-.5 0-.7-.1-.2-1-2.4-1.3-3.2-.4-.9-.7-.8-1-.8h-.9c-.3 0-.7.1-1 .5-.4.4-1.3 1.3-1.3 3.1 0 1.8 1.3 3.6 1.5 3.9.2.3 2.6 4 6.4 5.6.9.4 1.6.7 2.2.9.9.3 1.8.3 2.4.2.7-.1 2.3-.9 2.6-1.8.3-.9.3-1.6.2-1.8-.1-.2-.4-.3-.8-.5Z"
                    fill="#0b1220"
                    opacity="0.92"
                  />
                </svg>
                Chat with Support
              </a>
            </p>
          </div>

          <nav className="footer-nav" aria-label="Site links">
            <p className="footer-nav-heading">Explore</p>
            <ul className="footer-nav-list">
              {siteLinks.map(({ to, label }) => (
                <li key={to}>
                  <Link className="footer-link" to={to}>
                    {label}
                  </Link>
                </li>
              ))}
            </ul>
          </nav>

          <nav className="footer-nav" aria-label="Legal">
            <p className="footer-nav-heading">Legal</p>
            <ul className="footer-nav-list">
              {legalLinks.map(({ to, label }) => (
                <li key={to}>
                  <Link className="footer-link" to={to} rel="nofollow">
                    {label}
                  </Link>
                </li>
              ))}
            </ul>
          </nav>
        </div>

        <div className="footer-bottom">
          <p className="footer-copyline">
            <span className="footer-copy-main">© {new Date().getFullYear()} Notrack</span>
            <span className="footer-copy-sep" aria-hidden>
              ·
            </span>
            <span className="footer-copy-sub">Not medical advice—see a clinician for health conditions.</span>
          </p>
        </div>
      </div>
    </footer>
  );
}
